module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/34681d6734afe946503f0bfa996611e5.gif";